(() => {
    if (window.Shopify?.designMode) return;
    const storageKey = "loew:collection-return:v1";
    const maxAge = 45 * 60 * 1000;
    const cardSelector = ".js-results product-card, .loew-discovery__card";
    const productHandle = value => {
        try {
            const url = new URL(value, location.href);
            return url.origin === location.origin ? url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1] || "" : "";
        } catch { return ""; }
    };
    const collectionUrl = value => {
        try {
            const url = new URL(value, location.href);
            if (url.origin !== location.origin || !/\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(url.pathname) || url.pathname.includes("/products/")) return null;
            url.hash = "";
            url.searchParams.delete("preview_theme_id");
            url.searchParams.delete("section_id");
            return url;
        } catch { return null; }
    };
    const urlKey = value => {
        const url = collectionUrl(value);
        if (!url) return "";
        const entries = Array.from(url.searchParams.entries()).sort(([a, av], [b, bv]) => a.localeCompare(b) || av.localeCompare(bv));
        return url.pathname + "?" + new URLSearchParams(entries).toString();
    };
    const read = () => {
        try {
            const record = JSON.parse(sessionStorage.getItem(storageKey));
            if (!record || Date.now() - record.time > maxAge || !collectionUrl(record.url) || !/^[a-z0-9-]+$/.test(record.token)) return null;
            return record;
        } catch { return null; }
    };
    const write = record => {
        try { sessionStorage.setItem(storageKey, JSON.stringify(record)); return true; }
        catch { return false; }
    };
    const cards = () => Array.from(document.querySelectorAll(cardSelector)).filter(card => card.getClientRects().length > 0);
    const findCard = record => cards().find(card => {
        if (record.productId && card.dataset.productId === record.productId) return true;
        return Array.from(card.querySelectorAll('a[href*="/products/"]')).some(a => productHandle(a.href) === record.handle);
    });
    const saveSource = event => {
        const link = event.target.closest?.("a[href]");
        const card = link?.closest(cardSelector);
        const handle = link && productHandle(link.href);
        const source = collectionUrl(location.href);
        if (!card || !handle || !source || link.hasAttribute("download")) return;
        if (event.type === "click" && event.button !== 0) return;
        if (event.type === "auxclick" && event.button !== 1) return;
        const root = document.querySelector('dynamic-product-search[data-loew-availability-mode="collection"]');
        const basePage = Number(source.searchParams.get("page")) || 1;
        const throughPage = Number(root?.dataset.loewCurrentPage) || basePage;
        const record = {
            token: crypto.randomUUID(), time: Date.now(), url: source.pathname + source.search,
            handle, productId: card.dataset.productId || "",
            label: document.querySelector(".loew-collection-heading h1, #main h1")?.textContent.trim() || "",
            scrollY: window.scrollY, offset: card.getBoundingClientRect().top,
            throughPage: Math.max(basePage, Math.min(throughPage, basePage + 49))
        };
        write(record);
    };
    const updateBreadcrumb = () => {
        const product = document.querySelector("product-single[data-product-id]");
        const nav = document.querySelector(".breadcrumb--product-single");
        const record = read();
        if (!product || !nav || !record || productHandle(location.href) !== record.handle) return;
        if (record.productId && product.dataset.productId !== record.productId) return;
        const fromSource = urlKey(document.referrer) === urlKey(record.url);
        const fromProduct = productHandle(document.referrer) === record.handle;
        if (!fromSource && !fromProduct) return;
        let link = nav.querySelector("[data-loew-collection-return]");
        if (!link) {
            const list = nav.querySelector("ol");
            const first = list?.querySelector("li");
            if (!first) return;
            const item = first.cloneNode(true);
            link = item.querySelector("a");
            if (!link) return;
            link.setAttribute("data-loew-collection-return", "");
            list.insertBefore(item, list.lastElementChild);
            Array.from(list.children).forEach((li, index) => {
                li.querySelector('meta[itemprop="position"]')?.setAttribute("content", String(index + 1));
            });
        }
        link.href = record.url + "#loew-return=" + record.token;
        link.setAttribute("itemid", new URL(record.url, location.origin).href);
        link.removeAttribute("title");
        const label = link.querySelector('[itemprop="name"]');
        if (label && record.label) label.textContent = record.label;
    };
    const waitForLoad = (root, signal) => new Promise(resolve => {
        let timer;
        const done = event => {
            clearTimeout(timer);
            root.removeEventListener("on:dynamic-product-search:loaded", done);
            root.removeEventListener("on:dynamic-product-search:failed", done);
            signal.removeEventListener("abort", done);
            resolve(event?.type === "on:dynamic-product-search:loaded");
        };
        root.addEventListener("on:dynamic-product-search:loaded", done, { once: true });
        root.addEventListener("on:dynamic-product-search:failed", done, { once: true });
        signal.addEventListener("abort", done, { once: true });
        timer = setTimeout(done, 12000);
    });
    const waitForCard = (record, signal) => new Promise(resolve => {
        if (findCard(record)) return resolve();
        let timer;
        const done = () => { clearTimeout(timer); observer.disconnect(); signal.removeEventListener("abort", done); resolve(); };
        const observer = new MutationObserver(() => { if (findCard(record)) done(); });
        observer.observe(document.querySelector("#main") || document.body, { childList: true, subtree: true });
        signal.addEventListener("abort", done, { once: true });
        timer = setTimeout(done, 8000);
    });
    const restore = async () => {
        const token = location.hash.match(/^#loew-return=([a-z0-9-]+)$/)?.[1];
        const record = read();
        if (!token || !record || record.token !== token || urlKey(location.href) !== urlKey(record.url)) return;
        history.replaceState(history.state, "", location.pathname + location.search);
        const controller = new AbortController();
        const cancel = () => controller.abort();
        const events = ["wheel", "touchstart", "pointerdown", "keydown"];
        const deadline = Date.now() + 20000;
        events.forEach(name => window.addEventListener(name, cancel, { passive: true, once: true }));
        try {
            const root = document.querySelector('dynamic-product-search[data-loew-availability-mode="collection"]');
            const startPage = Number(new URL(record.url, location.href).searchParams.get("page")) || 1;
            if (root?.dataset.infinite === "true") {
                const readyDeadline = Date.now() + 2500;
                while (!root.infiniteController && Date.now() < readyDeadline && !controller.signal.aborted) {
                    await new Promise(resolve => setTimeout(resolve, 50));
                }
                for (let i = 0; i < 49 && !controller.signal.aborted && Date.now() < deadline; i++) {
                    if (controller.signal.aborted) return;
                    if (!root.infiniteController) break;
                    if (root.loading) { if (!await waitForLoad(root, controller.signal)) break; }
                    const currentPage = Number(root.dataset.loewCurrentPage) || startPage;
                    if (currentPage >= record.throughPage) break;
                    const next = root.infiniteController.getNextPageUrl();
                    if (!next || Number(new URL(next, location.href).searchParams.get("page")) !== currentPage + 1) break;
                    const loaded = waitForLoad(root, controller.signal);
                    root.infiniteController.onLoadMore();
                    if (!await loaded) {
                        if (!root.loading && root.infiniteController.isLoadMoreLoading) {
                            root.infiniteController.isLoadMoreLoading = false;
                            root.infiniteController.previousResultsHTML = "";
                            root.infiniteController.setButtonIdleState();
                        }
                        break;
                    }
                }
            } else if (!root && !findCard(record)) {
                await waitForCard(record, controller.signal);
            }
            if (controller.signal.aborted) return;
            await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
            if (controller.signal.aborted) return;
            const card = findCard(record);
            const header = document.querySelector("header-container");
            const minOffset = (header?.getBoundingClientRect().height || 0) + 20;
            const offset = Math.max(minOffset, Math.min(Number(record.offset) || minOffset, innerHeight * .65));
            const scrollToCard = () => {
                const top = card ? window.scrollY + card.getBoundingClientRect().top - offset : Number(record.scrollY) || 0;
                window.scrollTo({ top: Math.max(0, top), behavior: "instant" });
            };
            scrollToCard();
            await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
            if (!controller.signal.aborted && card) scrollToCard();
        } finally {
            events.forEach(name => window.removeEventListener(name, cancel));
        }
    };
    document.addEventListener("click", saveSource, true);
    document.addEventListener("auxclick", saveSource, true);
    document.addEventListener("contextmenu", saveSource, true);
    const start = () => { updateBreadcrumb(); restore().catch(() => {}); };
    if (document.readyState !== "complete") document.addEventListener("DOMContentLoaded", start, { once: true });
    else start();
})();
